import Vue from "vue";
import VeeValidate from "vee-validate";
import VueMomentLib from "vue-moment-lib";
import VueSweetalert2 from "vue-sweetalert2";

import vuetify from "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "./plugins/axios";
import VueSocialauth from "vue-social-auth";
import VueProgressBar from "vue-progressbar";
import VueEditor from "vue2-editor";
import VueQuillEditor from "vue-quill-editor";

import Main from "./layouts/Main.vue";
import None from "./layouts/None.vue";

import "./plugins/veeValidate";

// require styles
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

Vue.use(VeeValidate);
Vue.use(VueMomentLib);
Vue.use(VueSweetalert2);
Vue.use(VueEditor);
Vue.use(VueQuillEditor /* { default global options } */);

Vue.component("main-layout", Main);
Vue.component("none-layout", None);
Vue.use(VueSocialauth, {
  providers: {
    facebook: {
      clientId: "319834325560387",
      redirectUri: "http://localhost:8081/auth/facebook/callback" // Your client app URL
    }
  }
});

Vue.use(VueProgressBar, {
  color: "#ffffff",
  failedColor: "#874b4b",
  thickness: "3px",
  transition: {
    speed: "0.2s",
    opacity: "0.6s",
    termination: 3000
  },
  autoRevert: true,
  inverse: false,
  autoFinish: false
});

Vue.config.productionTip = false;

import "./assets/css/admin.css";

function getAllPageRoute(list, pages) {
  list.forEach(item => {
    pages.push(item.route.toLowerCase());
  });
}

router.beforeEach((to, from, next) => {
  if (to.meta.layout == "main") {
    if (
      store.state.base.auth.forceChangePassword &&
      to.path != "/account/changepassword"
    ) {
      router.push("/account/changepassword");
    } else {
      let pages = [];
      getAllPageRoute(store.state.base.auth.allMenu, pages);
      let checkpages = pages.filter(item => {
        let toPath = to.path.toLowerCase();
        return toPath.indexOf(item) > -1 && item != "";
      });
      if (
        to.path != "/" &&
        to.path != "/account/changepassword" &&
        checkpages.length == 0
      ) {
        router.push("/401");
      }
      next();
    }
  } else next();
});

new Vue({
  router,
  axios,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
